import axios from 'axios';
import { validDocumentFileType } from '../utils/fileHelper';
import { addToast } from '../utils/toastNotifications';
import { endpoints } from '../utils/URL';
import { IComplianceUpdateDTO } from '../interface/ComplianceInterface';

export const postComplianceAsync = async (data: IComplianceUpdateDTO) => {
  const url = `${endpoints.compliance.mainUrl}`;
  try {
    const response = await axios.put(url, data);
    return { data: response.data, success: true };
  } catch (error: any) {
    addToast('An error occurred while updating compliance information', 'error');
    return { data: null, success: false };
  }
};

export const getCompliance = async (data: any) => {};

export const uploadFileAsync = async (
  inputId: string,
  progressBarId: string,
  pharmacyCode: string,
  successFn?: Function,
  errorFn?: Function
) => {
  let fileUpload: any = document.getElementById(inputId);

  let isFormValid = document.getElementById(inputId);
  if (!isFormValid) {
    addToast('Select a file');
    return;
  }

  let uploadedFiles = fileUpload.files;

  if (uploadedFiles.length === 0) {
    addToast('No files selected. Please select a csv file', 'warning');
    return;
  }

  if (!validDocumentFileType(uploadedFiles[0])) {
    addToast('Wrong file. Upload an document', 'warning');
    return;
  }

  if (uploadedFiles[0].size > 2097152) {
    //if exceeding 2mb
    addToast('Exceed file limit. Max limit is 2MB', 'warning');
    return;
  }

  //   event.preventDefault();

  const formData = new FormData();
  formData.append('formFile', uploadedFiles[0]);
  formData.append('pharmacyCode', pharmacyCode);

  let url = `${endpoints.compliance.mainUrl}/files`;
  let progressBar = document.getElementById(progressBarId) as HTMLElement;
  progressBar.style.width = `0%`;

  var config = {
    onUploadProgress: function (progressEvent: any) {
      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      progressBar.style.width = `${[percentCompleted]}%`;
    },
  };

  try {
    const response = await axios.post(url, formData, config);
    if (successFn) {
      successFn(response.data);
      // setProgressState('progress-bar bg-success');
      // setFileUrl(response.data);
      // setInitialExportData({
      //   ...defaultReportData,
      //   [selectedFileType]: response.data,
      // });
    }

    addToast('File uploaded successfully', 'success');
    //addT
  } catch (error: any) {
    if (error.response && error.response.status === 422) {
      addToast('Please check the file type', 'error');
    }
    progressBar.style.width = `0%`;

    if (errorFn) {
      errorFn();
    }
  } finally {
  }
};
